<script>
    import { onMount } from "svelte";
    //import * as particlesConfig from "./particlesjs-config.json";
    let particlesConfig = {
		backgroundMode: {
			enable: true,
			zIndex: 200
		},
		fpsLimit: 90,
		interactivity: {
			detectsOn: "window",
			events: {
				resize: true
			}
		},
		particles: {
			color: { value: "#fff" },
			move: {
				direction: "bottom",
				enable: true,
				outModes: { default:"out" },
				random: false,
				size: true,
				speed: 2,
				straight: false
			},
			number: { density: { enable: true, area: 400 }, value: 128 },
			opacity: {
				random: true,
				value: 0.75
			},
			shape: {
				type: "circle"
			},
			size: {
				random: true,
				value: 3
			}
		},
		detectRetina: true
	}

    let ParticlesComponent;

    onMount(async () => {
        const module = await import("svelte-particles");
        ParticlesComponent - module.default;
    });

    let onParticlesLoaded = (event) => {
        const particlesContainer = event.detail.particles;
    };
</script>

<svelte:component
    this={ParticlesComponent}
    id="tsparticles"
    class="particles"
    options={particlesConfig}
    on:particlesLoaded={onParticlesLoaded}
/>
